// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + chunkId + "-" + {"771":"c2dfd8bc","873":"b19bbbd1"}[chunkId] + ".css";
};